import { Text } from "@clipboard-health/ui-react";
import { Alert, Box, Button, CircularProgress, Link, Stack, TextField } from "@mui/material";
import { type ReactElement, useState } from "react";

interface ForgotPasswordFormProps {
  isSubmitting: boolean;
  error: string | undefined;
  onSubmit: (email: string) => void;
  onBackToLogin: () => void;
}

export function ForgotPasswordForm({
  isSubmitting,
  error,
  onSubmit,
  onBackToLogin,
}: ForgotPasswordFormProps): ReactElement {
  const [email, setEmail] = useState("");

  return (
    <Stack spacing={2.5}>
      <Text align="center" variant="h4">
        Reset your password
      </Text>
      <Alert severity="info" sx={{ textAlign: "left" }}>
        Enter your email address and we will send you a link to reset your password.
      </Alert>
      {error && (
        <Alert severity="error" sx={{ textAlign: "left" }}>
          {error}
        </Alert>
      )}
      <Box
        noValidate
        component="form"
        onSubmit={(formEvent: React.FormEvent) => {
          formEvent.preventDefault();
          onSubmit(email.trim());
        }}
      >
        <Stack spacing={2}>
          <TextField
            fullWidth
            required
            autoComplete="email"
            disabled={isSubmitting}
            label="Email Address"
            size="small"
            type="email"
            value={email}
            onChange={(event) => {
              setEmail(event.target.value);
            }}
          />
          <Button
            fullWidth
            disabled={isSubmitting || !email.trim()}
            type="submit"
            variant="contained"
          >
            {isSubmitting ? <CircularProgress size={24} /> : "Send Reset Link"}
          </Button>
          <Link
            component="button"
            sx={{ alignSelf: "center" }}
            type="button"
            underline="hover"
            variant="body2"
            onClick={onBackToLogin}
          >
            Back to sign in with password
          </Link>
        </Stack>
      </Box>
    </Stack>
  );
}
